// extracted by extract-css-chunks-webpack-plugin
module.exports = {"breadcrumbs-container":"breadcrumbs-container___-S_dh","breadcrumb":"breadcrumb___6RvCK","chevron":"chevron___1nV3p"};